import type { NextPage } from 'next'

import { SanityContentPage } from 'src/components/layouts/Page/SanityContentPage'

const BlogPage: NextPage = () => {
  return <SanityContentPage slug='blog' />
}

export default BlogPage
